var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary clearfix",class:("tx-" + _vm.getClass)},[_c('div',{staticClass:"dot l",class:("bg-" + _vm.getClass)}),_c('div',{staticClass:"txt l"},[_vm._v(" "+_vm._s(_vm.getText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }